import ISlim from './components/iSlim';
import ICare from './components/iCare';
import IGlow from './components/iGlow';
import Leadership from './pages/Leadership';
import ICoffee from './components/iCoffee';
import ICharge from './components/iCharge';
import Events from './pages/Events';
import Products from './pages/Products';
import Opportunity from './pages/Opportunity';
import IPulse from './components/iPulse';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Statutory from './pages/Statutory';
import InternationalEvent from './components/IntenationalEvent';
import IndianTrip from './components/IndianEvent';

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-900">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-white mb-4">404</h1>
      <p className="text-xl text-slate-400 mb-8">Page not found</p>
      <a href="/" className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-full hover:shadow-xl transition-all">
        Go Home
      </a>
    </div>
  </div>
);

export const routes = [
  { path: '/', element: <Home /> },
  { path: '/about-us', element: <AboutUs /> },
  { path: '/leadership', element: <Leadership /> },
  { path: '/events', element: <Events /> },
  { path: '/products', element: <Products /> },
  { path: '/opportunity', element: <Opportunity /> },
  { path: '/statutory', element: <Statutory /> },
  { path: '/products/ipulse', element: <IPulse /> },
  { path: '/products/islim', element: <ISlim /> },
  { path: '/products/icare', element: <ICare /> },
  { path: '/products/iglow', element: <IGlow /> },
  { path: '/products/icoffee', element: <ICoffee /> },
  { path: '/products/icharge', element: <ICharge /> },
  { path: '/international-event', element: <InternationalEvent /> },
  { path: '/indian-event', element: <IndianTrip /> },
  { path: '*', element: <NotFound /> },
];